/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useDispatch } from 'react-redux';
// material
import { Button, displayModal } from '@insticator/insticator-ui'
import { SectionGroupV2 } from 'material/expandablesection/v2'
// content
import SetThemeConfirm from './setthemeconfirm/setthemeconfirm';
// styles
import injectSheet from 'react-jss'
import styles from './settheme_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : SET THEME FOR ALL PRODUCTS ~~~~~~~~~~ ========== */
const SetTheme = injectSheet(styles)((props) => {
  const dispatch = useDispatch()

  const showConfirmModal = () => dispatch(displayModal(true, <SetThemeConfirm /> ))

  return (
    <SectionGroupV2 
      klass={`settheme ${props.classes.settheme}`}
      title={'Set theme for all products'} 
      description={'Use this theme across all COOL Media products for this domain’s commenting, trivia/polls, reactions, and related content.'}
    >
      <Button 
        name={'setthemebutton'}
        type={'action'} 
        variant={'system'} 
        text={'Set Theme for All Products'}
        handleClick={showConfirmModal}
      />
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SetTheme